import { makeStyles } from 'tss-react/mui';

const useStylesGridItem: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  gridItemFullWidth: {
    width: '100%',
  },
  gridItemLargeWidth: {
    width: '60%',
  },
  gridItemMediumWidth: {
    width: '50%',
  },
  gridItemSmallWidth: {
    width: '30%',
  },
}));

export default useStylesGridItem;
